import Toast from "javascripts/common/toast";
import MicroModal from "micromodal";
import { micromodal } from "javascripts/micromodal";

document.addEventListener("DOMContentLoaded", () => {
  // eslint-disable-next-line no-undef
  if (document.getElementById("js-trip_lists") && s.Util.getQueryParam("share") === "1") {
    const tripListsShareModal = document.getElementById("target-trip-lists-share");
    if (tripListsShareModal) {
      micromodal("target-trip-lists-share");
    }
  }

  // 追加・削除ボタンの有効/無効を制御
  if (document.querySelector("#js-bulk_clips.bulk_clips-new") || document.querySelector("#js-bulk_clips.bulk_clips-show")) {
    const notAllChecked = () => Array.from(document.querySelectorAll(".js-trip-lists__checkbox")).every((checkbox) => checkbox.checked === false);

    const checkboxes = document.querySelectorAll(".js-trip-lists__checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const submitButton = document.querySelector(".js-trip-lists__submit");
        if (submitButton) {
          submitButton.disabled = notAllChecked();
        }
      });
    });

    const submitButtons = document.querySelectorAll(".js-trip-lists__submit");
    submitButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (notAllChecked()) {
          alert("クリップが選択されていません。");
          return false;
        }
      });
    });

    const bulkClipsForms = document.querySelectorAll(".js-bulk-clips-form");
    bulkClipsForms.forEach((form) => {
      form.addEventListener("submit", () => {
        const event24Count = document.querySelectorAll(".js-trip-list-add-presses-checkbox:checked").length;
        const event25Count = document.querySelectorAll(".js-trip-list-add-spots-checkbox:checked").length;
        // eslint-disable-next-line no-undef
        onclickcatalyst_triplist("ユーザー-Tripリスト-クリップ追加", `event24=${event24Count},event25=${event25Count}`);
        return true;
      });
    });
  }

  document.addEventListener("ajax:success", (event) => {
    const target = event.target;
    if (target.hasAttribute("data-triplist-modal")) {
      const modalTarget = target.dataset.modalTarget || "#target-lists-create";
      const modalElement = document.querySelector(modalTarget);
      if (modalElement) {
        modalElement.innerHTML = event.detail[0].body.innerHTML;
        micromodal(modalElement.id);
      }
    }
  });

  document.addEventListener("ajax:success", (event) => {
    const target = event.target;
    if (target.closest(".js-trip-list-create")) {
      const { error_form, list_items, list_add, clipable_type } = event.detail[0];

      if (error_form != null) {
        const targetElement = document.getElementById("target-lists-create");
        if (targetElement) {
          targetElement.innerHTML = error_form;
        }
        return;
      }

      MicroModal.close("target-lists-create");

      const noResultsHeading = document.querySelector(".c-no-results h3.c-no-results__heading");
      if (noResultsHeading) {
        noResultsHeading.style.display = "none";
      }

      const createListItem = document.querySelector("li.c-trip-lists__item--create");
      if (createListItem) {
        createListItem.insertAdjacentHTML("afterend", list_items);
      }

      setTimeout(() => {
        listAddedToast(list_add);
      }, 300);

      tripListAdded(clipable_type);
    }
  });

  document.addEventListener("ajax:success", (event) => {
    const target = event.target;
    if (target.closest(".js-trip-lists-add-link")) {
      const { error_message, triplist_id, list_item, list_add, clipable_type } = event.detail[0];

      if (error_message != null) {
        listAddedToast(error_message);
        return;
      }

      const targetListItem = document.getElementById(`target-list-item-${triplist_id}`);
      if (targetListItem) {
        targetListItem.innerHTML = list_item;
      }
      listAddedToast(list_add);
      tripListClipAdded(clipable_type);
    }
  });

  const listAddedToast = (addItem) => {
    const listsAddEl = document.getElementById("target-lists-add");

    listsAddEl.innerHTML = addItem;

    const listsAddToast = new Toast(listsAddEl);
    listsAddToast.show();

    MicroModal.close("target-lists");
    MicroModal.close("target-clip-to-lists");
  };

  const tripListAdded = (clipable_type) => {
    let eventparam = "event23";
    if (clipable_type === "press") eventparam += ",event24=1";
    if (clipable_type === "spot") eventparam += ",event25=1";
    const catalystProps = document.getElementById("catalyst-props");
    if (catalystProps) {
      // eslint-disable-next-line no-undef
      onclickcatalyst_triplist(catalystProps.dataset.prop1.replace("_", "-"), eventparam);
    }
  };

  const tripListClipAdded = (clipable_type) => {
    let eventparam = "";
    if (clipable_type === "press") eventparam += "event24=1";
    if (clipable_type === "spot") eventparam += "event25=1";
    const catalystProps = document.getElementById("catalyst-props");
    if (catalystProps) {
      // eslint-disable-next-line no-undef
      onclickcatalyst_triplist(catalystProps.dataset.prop1.replace("_", "-"), eventparam);
    }
  };
});
